/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamRevisionLangBotexamlangidQuestion202,
  PostApiV1ExamRevisionLangBotexamlangidQuestion400,
  PostApiV1ExamRevisionLangBotexamlangidQuestion401,
  PostApiV1ExamRevisionLangBotexamlangidQuestion500,
  PostApiV1ExamRevisionLangBotexamlangidQuestionMutationResponse,
  PostApiV1ExamRevisionLangBotexamlangidQuestionPathParams,
} from "../../types/examRevisionController/PostApiV1ExamRevisionLangBotexamlangidQuestion.ts";

export const postApiV1ExamRevisionLangBotexamlangidQuestionPathParamsSchema =
  z.object({
    botExamLangId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidQuestionPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1ExamRevisionLangBotexamlangidQuestion202Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidQuestion202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ExamRevisionLangBotexamlangidQuestion400Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidQuestion400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamRevisionLangBotexamlangidQuestion401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidQuestion401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamRevisionLangBotexamlangidQuestion500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidQuestion500>;

export const postApiV1ExamRevisionLangBotexamlangidQuestionMutationResponseSchema =
  z.lazy(
    () => postApiV1ExamRevisionLangBotexamlangidQuestion202Schema,
  ) as unknown as ToZod<PostApiV1ExamRevisionLangBotexamlangidQuestionMutationResponse>;
